import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtService } from 'src/app/services/jwt.service';
import { ApiService } from 'src/app/services/api.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';


@Component({
  selector: 'app-ship-activity',
  templateUrl: './ship-activity.component.html',
  styleUrls: ['./ship-activity.component.css'],
})
export class ShipActivityComponent implements OnInit {
  buttonClicked = false;
  currDate: Date;
  clients = JSON.parse(sessionStorage.getItem('clients'));

  ship = {
    client: '',
    id: '',
    from: Date,
    to: Date,
  };

  constructor(
    private snackbar: MatSnackBar,
    private jwt: JwtService,
    private api: ApiService,
    private mixpanel: MixpanelService
  ) {
    this.currDate = new Date();
  }

  ngOnInit(): void {
    this.mixpanel.track("page_view", { page: "Ship Activity", category: "Dashboard", button: "-"  })
    this.jwt.check();
  }

  getDateAsApiFormat(e) {
    e = new Date(e);
    return `${e.getFullYear()}-${this.twoDigit(
      e.getMonth() + 1
    )}-${this.twoDigit(e.getDate())}`;
  }

  twoDigit(e) {
    return String(
      Number(e).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
    );
  }

  getRes() {
    this.mixpanel.track("button_click", { page: "Ship Activity", category: "Dashboard", button: "Activity" })
    this.buttonClicked = true;
    let param = {
      client: this.ship.client,
      shipid: this.ship.id,
      fromDate: this.getDateAsApiFormat(this.ship.from),
      toDate: this.getDateAsApiFormat(this.ship.to),
    };
    this.api.shipActivity(param).subscribe((data: any) => {
      this.buttonClicked = false;
      if(data.status) {
        this.snackbar.open( data.message, undefined , {
          duration: 5000,
          panelClass: 'success'
        });
        window.open( data.data.link );
      } else {
        this.snackbar.open( data.message, undefined , {
          duration: 5000,
          panelClass: 'failure'
        });
        this.buttonClicked = false;
      }
    }, 
    ( error ) => {
      this.buttonClicked = false;
    });
  }
}
